<template>
  <div>
      <b-container>
          <b-row>        
                <b-col cols="2">
                    MFA Settings <b-button v-show="!editMfaPref" @click='editMfaPrefToggle' variant="info" size="sm">+</b-button>
                    <b-button v-show="editMfaPref" @click='editMfaPrefToggle' variant="info" size="sm">-</b-button>
                </b-col>
                <b-col cols="8">                   
                    <div v-show="editMfaPref" class="mfaPref border border-dark">

                        <b-card v-if="formState === 'prefSelect'" :header="'Change MFA Preference from '+ preferredMFADisplay" class="text-center" border-variant="light" align="left">
                            <!--b-card-text class="text-left">Multi-Factor Authentication (MFA) adds an extra layer of protection on top of your user name and password.</b-card-text-->

                            <b-form>
                                <b-form-group class="text-left">
                                    <b-form-radio v-show="showRadio('SMS')" v-model="selected" name="mfaVal" value="SMS" size="sm">Receive a code by SMS on your mobile device</b-form-radio>
                                    <b-form-radio v-show="showRadio('NOMFA')"  v-model="selected" name="mfaVal" value="NOMFA" size="sm">Disable MFA</b-form-radio>
                                    <b-form-radio v-show="showRadio('TOTP')" v-model="selected" name="mfaVal" value="TOTP" size='sm'>Use a QR code and MFA app on your mobile device</b-form-radio>
                                </b-form-group>

                                <b-alert v-if="lastError" show variant="danger" align="center" class="m-2" style="height:auto; font-size:15px; valign:center">
                                    <div>{{lastError}}</div>                        
                                </b-alert>

                                <div align="right">
                                        <b-button @click='editMfaPrefToggle' variant="info" size="sm" class="mr-2">Cancel</b-button>
                                        <b-button @click='submitPrefSelect' variant="info" size="sm" >Submit</b-button>
                                </div>
                            
                            </b-form>
                        </b-card>    


                        <b-card v-if="formState === 'verifyToken'" header="Verify Authentication Token" class="text-center" border-variant="light" align="left">
                            <!--b-card-text class="text-left">Multi-Factor Authentication (MFA) adds an extra layer of protection on top of your user name and password.</b-card-text-->


                            <b-form>
                                <b-form-row> 
                                    <b-col cols="auto">
                                        <qrcode-vue :value="qrcode" v-show="qrcode!==''" align="left"></qrcode-vue>
                                    </b-col>
                                    <b-col class="text-left">
                                        <i>Scan the QR Code with your phone camera or authentication app to get the MFA code.</i>
                                        <b-form-group
                                            id="code"
                                            label="Verification Code:"
                                            label-for="verificationCode"
                                            label-cols-lg="6"
                                            label-size="sm"
                                            label-align-sm="right"

                                        >
                                        <b-form-input
                                            id="verificationCode"
                                            type="text"
                                            required
                                            placeholder="Enter Code"
                                            autocomplete="off"
                                            size="sm"
                                            v-model="verificationCode"
                                        ></b-form-input>
                                        </b-form-group>
                                    </b-col>

                                </b-form-row>
                                <b-alert v-if="lastTOTPError" show variant="danger" align="center" class="m-2" style="height:auto; font-size:15px; valign:center">
                                    <div>{{lastTOTPError}}</div>                        
                                </b-alert>

                                <div align="right">
                                        <b-button @click='editMfaPrefToggle' variant="info" size="sm" class="mr-2">Cancel</b-button>
                                        <b-button @click='submitTOTP' variant="info" size="sm" >Verify</b-button>
                                </div>


                            </b-form>
                        </b-card>
                    </div>
                </b-col>
            </b-row>    
        </b-container>
  </div>
</template>


<script>
import { Auth } from 'aws-amplify'
import { mapGetters } from 'vuex'
import QrcodeVue from 'qrcode.vue'

export default {
    name: 'MfaSelect',
    data() {
        return {
            qrcode:'',
            preferredMFA:'',
            mfaConfig: {
                mfaTypes: ['SMS','TOTP','None'],
            },
            editMfaPref:false,
            formState:'prefSelect',
            selected:'',
            verificationCode:'',
            lastError:'',
            lastTOTPError:'',
            mfaOptions:null
        }
    },
    created () {
        this.getPreferredMFA()
        this.mfaOptions = process.env.VUE_APP_ALLOWED_MFA_OPTIONS
    },
    components: {
        QrcodeVue,
    },
    computed: {
        ...mapGetters('authstore', {
        user: 'user',
        userName: 'userName'
        }),
        preferredMFADisplay(){
            if (this.preferredMFA==='SMS_MFA'){
                return 'SMS'
            } else if (this.preferredMFA==='SOFTWARE_TOKEN_MFA') {
                return 'Software Token'
            } else if (this.preferredMFA==='NOMFA') {
                return 'None'
            } else {
                return '...'
            }
        }
    },
    methods: {
        showRadio(type){
            if ( (type==='SMS') && this.mfaOptions.includes('SMS') && ((this.preferredMFA === 'SOFTWARE_TOKEN_MFA') || (this.preferredMFA === 'NOMFA')) ){
                return true               
            } else if ((type==='NOMFA') && this.mfaOptions.includes('NOMFA') && ((this.preferredMFA === 'SOFTWARE_TOKEN_MFA') || (this.preferredMFA === 'SMS_MFA') )){
                return true
            } else if ((type==='TOTP') && this.mfaOptions.includes('TOTP') && ((this.preferredMFA === 'NOMFA') || (this.preferredMFA === 'SMS_MFA') )){
                return true
            }
        },
        editMfaPrefToggle(){
            this.editMfaPref = !this.editMfaPref
            if(this.editMfaPref){
                this.formState = 'prefSelect'
                this.preferredMFA=''
                this.getPreferredMFA()
                this.selected=''
                this.qrcode='',
                this.lastTOTPError='',
                this.lastError='',
                this.verificationCode=''
            }
        },
        async getPreferredMFA() {
            await Auth.getPreferredMFA(this.user,{
                // Optional, by default is false. 
                // If set to true, it will get the MFA type from server side instead of from local cache.
                bypassCache: true 
            }).then((data) => {
                this.preferredMFA=data
            })
        },
        async setPreferredMFA(selected) {
            await Auth.setPreferredMFA(this.user, selected).then(() => {
                this.editMfaPrefToggle()
            }).catch(e => {
                this.lastError=e.message
            })
        },
        async setupTOTP() {
            await Auth.setupTOTP(this.user).then((code) => {
                this.formState = 'verifyToken'
                this.qrcode= "otpauth://totp/EchoOpsPortal:"+this.userName+"?secret=" + code
            }).catch(e => {
                this.lastError = e.message
            })
        },
        submitPrefSelect(){   
            if (this.selected === ''){
                this.lastError = 'Invalid selection, please try again.'
            } else {
                this.lastError = ''
                if (this.selected === 'TOTP'){
                    this.setupTOTP()
                } else  {
                    this.setPreferredMFA(this.selected)  
                }
            }            
        },
        async submitTOTP(){
            try {
                await Auth.verifyTotpToken(this.user, this.verificationCode)
                await Auth.setPreferredMFA(this.user, 'TOTP')
                this.editMfaPrefToggle()
            } catch(e) {
                this.lastTOTPError=e.message
            }  
        },
    }
}
</script>

<style>
.mfaPref {
  margin: 0 auto;
  width: 390px;
}
</style>